import isEmpty from "~/kernel/arrays/isEmpty";
import isString from "~/kernel/strings/isString";

export const SortOrder = Object.freeze({
  ASC: 1,
  DESC: -1,
  NONE: 0,
});

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder];

function hasStringValues<T>(
  getProp: ((item: T) => number) | ((item: T) => string),
  value: T,
): getProp is (item: T) => string {
  return isString(getProp(value));
}

export default function sortBy<T>(
  array: T[],
  getProp: ((item: T) => number) | ((item: T) => string),
  order: SortOrder = SortOrder.ASC,
) {
  if (isEmpty(array)) {
    return array;
  }

  const firstValue = array[0];
  const hasStrings = hasStringValues(getProp, firstValue);

  if (hasStrings) {
    return [...array].sort((left, right) => {
      const leftProp = getProp(left);
      const rightProp = getProp(right);
      return leftProp.localeCompare(rightProp) * order;
    });
  }

  return [...array].sort((left, right) => {
    const leftProp = getProp(left);
    const rightProp = getProp(right);
    return leftProp * order - rightProp * order;
  });
}
